export default __webpack_public_path__ + "static/media/R5C_8086.0837469b.jpg";